<template>
  <div class="space-y-6">
    <div class="flex items-center justify-between">
      <h2 class="text-primary font-bold" style="font-size:1.5625rem;">Категории</h2>
      <button
        v-if="cartItems && cartItems.length >= 0"
        class="inline-flex items-center justify-center bg-accent text-white rounded-[0.625rem] p-2 relative"
        @click="$emit('open-cart')"
        aria-label="Корзина"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
            <path d="M20.0351 7.5337C19.9361 6.61887 19.4969 5.77464 18.8048 5.1683C18.1126 4.56197 17.2179 4.23779 16.298 4.26H15.2367C15.0546 3.22066 14.5119 2.2788 13.7039 1.60009C12.896 0.921391 11.8746 0.549316 10.8194 0.549316C9.76427 0.549316 8.74289 0.921391 7.93495 1.60009C7.12702 2.2788 6.58428 3.22066 6.4022 4.26H5.32592C4.40601 4.23779 3.51133 4.56197 2.81917 5.1683C2.12701 5.77464 1.68789 6.61887 1.58883 7.5337L0.654557 17.5192C0.607723 18.009 0.66473 18.5031 0.821855 18.9693C0.978979 19.4355 1.23269 19.8634 1.56641 20.2249C1.92446 20.6126 2.35913 20.9218 2.84288 21.1327C3.32664 21.3437 3.84893 21.452 4.3767 21.4506H17.2622C17.79 21.452 18.3123 21.3437 18.796 21.1327C19.2798 20.9218 19.7144 20.6126 20.0725 20.2249C20.4062 19.8634 20.6599 19.4355 20.817 18.9693C20.9742 18.5031 21.0312 18.009 20.9843 17.5192L20.0351 7.5337ZM10.8194 2.01775C11.4806 2.0199 12.1224 2.24113 12.6444 2.64684C13.1664 3.05256 13.5392 3.61986 13.7045 4.26H7.93441C8.09969 3.61986 8.4725 3.05256 8.99452 2.64684C9.51654 2.24113 10.1583 2.0199 10.8194 2.01775V2.01775ZM18.9663 19.2084C18.7502 19.4451 18.4869 19.6338 18.1934 19.7626C17.8999 19.8913 17.5827 19.9571 17.2622 19.9558H4.3767C4.05621 19.9571 3.73898 19.8913 3.44548 19.7626C3.15197 19.6338 2.88868 19.4451 2.67259 19.2084C2.47967 19.0012 2.33268 18.7556 2.24124 18.4877C2.14979 18.2198 2.11594 17.9356 2.14192 17.6537L3.09861 7.67571C3.16033 7.13412 3.42383 6.63568 3.83661 6.27969C4.24939 5.9237 4.78115 5.7363 5.32592 5.75484H6.33494V7.24968C6.33494 7.44791 6.41368 7.63801 6.55385 7.77818C6.69402 7.91835 6.88413 7.9971 7.08235 7.9971C7.28058 7.9971 7.47069 7.91835 7.61086 7.77818C7.75103 7.63801 7.82977 7.44791 7.82977 7.24968V5.75484H13.8091V7.24968C13.8091 7.44791 13.8879 7.63801 14.028 7.77818C14.1682 7.91835 14.3583 7.9971 14.5565 7.9971C14.7548 7.9971 14.9449 7.91835 15.085 7.77818C15.2252 7.63801 15.304 7.44791 15.304 7.24968V5.75484H16.313C16.8603 5.73245 17.3957 5.9181 17.8117 6.27446C18.2277 6.63082 18.4934 7.13146 18.5552 7.67571L19.5119 17.6612C19.5349 17.943 19.4981 18.2264 19.4041 18.493C19.3101 18.7596 19.1609 19.0033 18.9663 19.2084V19.2084Z" fill="white"/>
          </svg>
        <span v-if="cartItems.length" class="absolute -top-1 -right-1 bg-white text-accent text-[10px] font-bold rounded-full min-w-[1.1rem] h-[1.1rem] flex items-center justify-center px-[2px] leading-none">
          {{ totalItems }}
        </span>
      </button>
    </div>
    <div class="flex gap-5 overflow-x-auto pb-1">
      <div
        v-for="cat in categories"
        :key="cat.id"
        class="flex flex-col items-center min-w-[70px]"
      >
        <button
          @click="$emit('update:modelValue', cat.id)"
          :class="[
            'rounded-full flex items-center justify-center w-16 h-16 p-2 transition border',
            isActive(cat.id) ? 'bg-accent border-accent' : 'bg-white border-white shadow-sm'
          ]"
        >
          <span
            v-html="colorizedIcon(cat)"
            class="pointer-events-none flex items-center justify-center"
          />
        </button>
        <span
          class="mt-2 text-center text-xs font-medium leading-tight"
          :class="isActive(cat.id) ? 'text-accent' : 'text-primary'"
        >{{ cat.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategorySelector',
  props: {
    categories: { type: Array, required: true },
    modelValue: { type: [Number, String, null], default: null },
    cartItems: { type: Array, default: () => [] }
  },
  emits: ['update:modelValue','remove-item','checkout','open-cart'],
  components:{ },
  methods:{
    isActive(id){ return this.modelValue === id },
    colorizedIcon(cat){
      // replace fill colors when active
      if(this.isActive(cat.id)){
        return cat.icon.replace(/fill=('|")#B7B7B7('|")/g, "fill='white'")
      }
      return cat.icon
    }
  },
  computed:{
    totalItems(){
      return this.cartItems.reduce((s,i)=> s + (i.quantity || 1), 0)
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar { height: 6px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 3px; }
</style>
